import { Component, ElementRef, ViewChild, OnInit, ViewEncapsulation } from '@angular/core';
import isNull from 'lodash-es/isNull';
import { EditableComponent } from '../editable.types';

@Component({
  templateUrl: './percent-editable.component.html',
  styleUrls: ['./percent-editable.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PercentEditableComponent extends EditableComponent implements OnInit {
  @ViewChild('inputEditorControl') inputEditorControl: ElementRef;

  public value: string = '';
  public editing: boolean = false;
  private _originalValue;
  public emptyCellOverlay;
  precision: number = 0;

  ngOnInit(): void {
    super.ngOnInit();

    //this.value = this.model[this.fieldDef.name] * 100;
    this.value = this.getValue();
    this.emptyCellOverlay = this.showEmptyHolder && isNull(this.value);
    this._originalValue = this.value;
    if (this.fieldDef.meta && this.fieldDef.meta.readonly) {
      this.readonly = this.fieldDef.meta.readonly;
    }
    if (this.fieldDef.meta && this.fieldDef.meta.scale !== null) {
      this.precision = this.fieldDef.meta.scale;
    }

    if (this.editMode) {
      this.editing = this.editMode;
      setTimeout(() => this.inputEditorControl.nativeElement.focus(), 100);
    }
  }

  edit() {
    if (!this.editing && !this.readonly) {
      this.editing = true;
      setTimeout(() => {
        this.inputEditorControl.nativeElement.focus();
      }, 100);
    }
  }

  onBlur($event: Event) {
    this.editing = false;

    if (this.value === '') {
      this.value = null;
    }

    if (this._originalValue != this.value) {
      this.updateModel();
      this.update.emit({ [this.fieldDef.name]: this.value });
    }

    this.onEndEditing.emit();
  }

  updateModel() {
    //this.model[this.fieldDef.name] = this.value / 100;
    this.model[this.fieldDef.name] = this.removeFormatting(this.value);
    this._originalValue = this.value;
    this.emptyCellOverlay = this.showEmptyHolder && isNull(this.value);
  }
}
